import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "kane_auth_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API, timeout: 30000 });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// On expired/invalid session, drop the token and reload to the login screen.
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken()) {
      clearToken();
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

// ---- Auth ----
export const login = (email, password) =>
  http.post("/auth/login", { email, password }).then((r) => r.data);
export const setPassword = (email, password) =>
  http.post("/auth/set-password", { email, password }).then((r) => r.data);
export const getMe = () => http.get("/auth/me").then((r) => r.data);

// ---- Admin: members ----
export const listUsers = () => http.get("/users").then((r) => r.data);
export const inviteUser = (email) => http.post("/users/invite", { email }).then((r) => r.data);
export const resetUser = (id) => http.post(`/users/${id}/reset`).then((r) => r.data);
export const removeUser = (id) => http.delete(`/users/${id}`).then((r) => r.data);

// ---- Videos / tags ----
export const getVideos = () => http.get("/videos").then((r) => r.data);
export const getTags = () => http.get("/tags").then((r) => r.data);
export const saveName = (rk, name) =>
  http.post(`/videos/${rk}/name`, { name }).then((r) => r.data);
export const addTag = (rk, tag) =>
  http.post(`/videos/${rk}/tags`, { tag }).then((r) => r.data);
export const removeTag = (rk, tag) =>
  http.delete(`/videos/${rk}/tags/${encodeURIComponent(tag)}`).then((r) => r.data);
export const saveYear = (rk, year) =>
  http.post(`/videos/${rk}/year`, { year }).then((r) => r.data);
export const splitVideo = (rk, segments) =>
  http.post(`/videos/${rk}/split`, segments).then((r) => r.data);

// Media tags can't send headers, so pass the token as a query param.
export const thumbUrl = (rk) => `${API}/thumb/${rk}?token=${getToken() || ""}`;
export const streamUrl = (rk) => `${API}/stream/${rk}?token=${getToken() || ""}`;

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// Title-case a freshly typed tag: "christmas day" -> "Christmas Day"
export const titleCase = (s) =>
  s
    .trim()
    .replace(/\s+/g, " ")
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w))
    .join(" ");

// Seconds -> "HH:MM:SS"
export const formatTime = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(sec)}`;
};
